<template>
	<div>
		<div class="flex w-full justify-center">
			<div class="max-w-8xl w-full justify-start md:justify-center">
				<div class="grid grid-cols-1 md:grid-cols-3 gap-y-2 gap-x-3 mx-4">
					<router-link
						:to="service.link"
						class="relative w-full justify-start px-2 flex bg-gradient-to-b from-ihh-pink via-ihh-pink to-ihh-purple rounded-lg shadow-md py-6 md:py-6 px-4 pr-2 group cursor-pointer"
						v-for="(service, i) in services"
						:key="i"
					>
						<img :src="service.image" alt="service Icons" class="w-10 h-10 bg-white rounded-md p-1 shadow-md" />
						<div class="pl-4">
							<div class="">
								<div class="pr-4">
									<div class="text-ihh-midnight-gray font-semibold text-sm md:text-lg overflow-hidden">{{ service.title }}</div>
									<div class="text-xs md:text-sm text-ihh-slate-gray pt-1">{{ service.subtitle }}</div>
								</div>
							</div>
							<div class="pt-4">
								<div class="absolute bottom-2 md:bottom-4">
									<div class="text-ihh-dark-salmon group-hover:text-ihh-salmon underline text-xs font-semibold">{{ service.linkTitle }}</div>
								</div>
							</div>
						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			services: [
				{
					title: 'Outstanding Customer Service',
					image: '/images/radiant_star.svg',
					subtitle: "Chat, Phone & SMS. We're here to help!",
					linkTitle: 'Contact us',
					link: '/help-center',
				},
				{
					title: 'Free Shipping',
					image: '/images/ob-shipping.svg',
					subtitle: 'Over $125 shipping to the lower 48',
					linkTitle: 'Learn More',
					link: '/shipping-info',
				},
				{
					title: 'Family owned and operated',
					image: '/images/ob-smiley0129.svg',
					subtitle: 'Since 1999 by the Youngblood family',
					linkTitle: 'About us',
					link: '/about-us',
				},
			],
		}
	},
}
</script>
